import Firebase from '../fireBaseInit';
import errorHandler from './errorHandler.mixins';

// Mixins for generic DB actions
// So use variables and not hardcoded names

export default {
  mixins: {
    errorHandler,
  },
  methods: {
    async getAllDocumentsMixin(collection) {
      // Cloud Firestore
      const snapshot = await Firebase.fireStoreDB.collection(collection).get();
      const countries = snapshot.docs.map(item => ({
        countries: item.id,
      }));

      return {
        countries,
      };
    },
    async getDBDataMixin(collection, document) {
      // Cloud Firestore
      const docRef = Firebase.fireStoreDB.collection(collection).doc(document);
      const data = await docRef.get().then((doc) => {
        if (doc.exists) {
          return doc.data();
        }
        // doc.data() will be undefined in this case
        this.errorHandlerMixin('No such document!');
        return false;
      }).catch((error) => {
        this.errorHandlerMixin('Something went wrong:', error);
        // We don't know what errors it may throw.
        console.warn(error);
      });

      return data;
    },
  },
};
